import {
  MutationSystem,
  useImmediateMutationSystem,
} from "@/lib/queuedMutations";
import type { AgendaItem } from "@repo/types";
import { sections } from "./itemSections/sections";
import { Button } from "@repo/ui/components/Base/Button";
import { cn } from "@repo/shared/utils";
import { isApprovalItem } from "./utilities";

export type SectionsNavBarProps = {
  navigateToSection: (sectionId: string) => void;
  agendaItem: AgendaItem | null;
  mutationSystem: MutationSystem;
};

export const SectionsNavBar = ({
  agendaItem,
  mutationSystem,
  navigateToSection,
}: SectionsNavBarProps) => {
  const mutationKey: string | null =
    "agendaItem:" + (agendaItem ? agendaItem!.id : "");

  const internalAgendaItem = useImmediateMutationSystem(
    mutationSystem,
    mutationKey,
    agendaItem!
  );

  return (
    <div className="flex flex-row items-center justify-center gap-x-2 my-1">
      {internalAgendaItem &&
        isApprovalItem(internalAgendaItem) &&
        sections.map((section) => {
          const isComplete =
            typeof section.isComplete === "function"
              ? section.isComplete(internalAgendaItem)
              : true;

          const variant = !isComplete ? "destructive" : "ghost";

          return (
            <Button
              key={section.id}
              variant={variant}
              className={cn("px-2 py-1 h-auto", "text-xs")}
              onClick={() => navigateToSection(section.id)}
            >
              {section.title ?? section.id}
            </Button>
          );
        })}
    </div>
  );
};
